module.exports = __webpack_public_path__ + "AakashkennethNogarSrivastava-1f99aec6.webp";